import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  noPadding?: boolean;
}

const base: React.CSSProperties = {
  borderRadius: 16,
  border: '1px solid var(--bd)',
  backgroundColor: 'var(--bg-card)',
  boxShadow: 'var(--shadow)',
  overflow: 'hidden',
  position: 'relative',
};

export function Card({ children, className = '', onClick, style, noPadding }: CardProps) {
  return (
    <div
      className={`card-depth ${className}`}
      onClick={onClick}
      style={{
        ...base,
        cursor: onClick ? 'pointer' : undefined,
        transition: onClick ? 'border-color 0.15s, background 0.15s' : undefined,
        ...style,
      }}
      onMouseEnter={onClick ? (e) => { (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(16,185,129,0.3)'; } : undefined}
      onMouseLeave={onClick ? (e) => { (e.currentTarget as HTMLDivElement).style.borderColor = 'var(--bd)'; } : undefined}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '', style }: { children: React.ReactNode; className?: string; style?: React.CSSProperties }) {
  return (
    <div
      className={className}
      style={{ padding: '16px 20px', borderBottom: '1px solid var(--bd-sub)', ...style }}
    >
      {children}
    </div>
  );
}

export function CardBody({ children, className = '', style }: { children: React.ReactNode; className?: string; style?: React.CSSProperties }) {
  return (
    <div className={className} style={{ padding: 20, ...style }}>
      {children}
    </div>
  );
}
